import { Modal } from 'antd';
import styled from 'styled-components';
import { Button as BaseButton } from '@packages/utils';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border: none;
  }

  .ant-modal-header {
    background-color: white;
    padding: 24px;
    margin: 0;
    border-bottom: none;
  }

  .ant-modal-title {
    color: #1b1a1c;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .ant-modal-body {
    padding: 0 24px 24px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px;
    margin-top: 24px;
    border-top: none;
  }

  .ant-modal-close {
    top: 20px;
    right: 20px;
  }

  .ant-modal-close-x {
    font-size: 42px;
    font-weight: 300;
    width: 24px;
    height: 24px;
    line-height: 24px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const CancelButton = styled(BaseButton)`
  border-radius: 8px;
  height: 40px;
  min-width: 120px;
  font-weight: 600;
`;

export const PrimaryButton = styled(BaseButton)`
  border-radius: 8px;
  height: 40px;
  min-width: 120px;
  font-weight: 600;
  background-color: #0077a0;
  border-color: #0077a0;

  &:hover,
  &:focus {
    background-color: #006699;
    border-color: #006699;
  }
`;

export const FormContainer = styled.div`
  .ant-form-item-label > label {
    font-weight: 500;
    color: #1b1a1c;
    font-family: Lato;

    &.ant-form-item-required::before {
      display: inline-block;
      margin-inline-end: 4px;
      color: #ff4d4f;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
    }
  }

  .ant-input,
  .ant-select .ant-select-selector {
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    padding: 8px 12px;
    height: 40px;

    &:hover {
      border-color: #0197b8;
    }

    &:focus,
    &.ant-select-focused .ant-select-selector {
      border-color: #005678;
      box-shadow: 0 0 0 2px rgba(0, 86, 120, 0.2);
    }
  }

  .ant-input::placeholder,
  .ant-select .ant-select-selection-placeholder {
    color: #bfbfbf;
  }

  .ant-form-item {
    margin-bottom: 20px;
  }

  .ant-form-item-explain-error {
    font-size: 12px;
    color: #ff4d4f;
    margin-top: 4px;
  }
`;
